import { Spacing } from '@persona-id/design-tokens';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Validator } from 'redux-form';
import { MEDIA_QUERIES } from 'shared/styles/variables';
import styled, { ThemeContext } from 'styled-components';

import { InputStyles } from 'lib/interfaces/input-styles';
import PiiAttributes from 'lib/interfaces/PiiAttributes';
import FormGroup from 'verify/components/FormGroup';
import ThemedFormInput from 'verify/components/ThemedFormInput';

const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 0;
`;

const InputContainer = styled.div`
  display: flex;
  column-gap: ${Spacing[4]};
  flex-direction: row;
  flex-wrap: none;

  > * {
    flex: auto;
  }

  @media ${MEDIA_QUERIES.isMobileSmall} {
    flex-direction: column;
  }
`;

interface ThemedFormNameInputProps {
  disabledNameFirst: boolean;
  disabledNameLast: boolean;
  validate: {
    firstName: Validator | Validator[];
    lastName: Validator | Validator[];
  };
}

const ThemedFormNameInput = ({
  disabledNameFirst,
  disabledNameLast,
  validate,
}: ThemedFormNameInputProps) => {
  const [t] = useTranslation();

  const { inputStyle } = useContext(ThemeContext);
  const hideLabel = inputStyle === InputStyles.Material;

  return (
    <StyledFormGroup>
      {!hideLabel && (
        <label htmlFor={PiiAttributes.NameFirst}>{t('database.form.name-label')}</label>
      )}
      <InputContainer>
        <Field
          name={PiiAttributes.NameFirst}
          component={ThemedFormInput}
          autoComplete='given-name'
          disabled={disabledNameFirst}
          placeholder={t('database.form.first_name')}
          type='text'
          validate={validate.firstName}
        />
        <Field
          name={PiiAttributes.NameLast}
          component={ThemedFormInput}
          autoComplete='family-name'
          disabled={disabledNameLast}
          placeholder={t('database.form.last_name')}
          type='text'
          validate={validate.lastName}
        />
      </InputContainer>
    </StyledFormGroup>
  );
};

export default ThemedFormNameInput;
